import { useTranslation } from 'react-i18next';

import { ICompanyDto } from '@/shared/api/companies';
import { useNotifications } from '@/shared/ui/Notifications';

import { useUpdateCompany } from './useUpdateCompany';

interface IUpdateCompanyNameData {
  companyId: string;
  name: string;
}

export function useCompanyName() {
  const { updateCompany, ...updateCompanyMutation } = useUpdateCompany();
  const { addNotification } = useNotifications();
  const { t } = useTranslation();

  const handleOnSuccess = () => {
    addNotification({
      type: 'success',
      title: t('company:settingsPage.notifications.success'),
    });
  };

  const getCompanyName = (company: ICompanyDto) => {
    if (company.name) return company.name;

    return company.id;
  };

  const updateCompanyName = async (
    data: IUpdateCompanyNameData
  ): Promise<ICompanyDto> => {
    return updateCompany(data, handleOnSuccess);
  };

  const setCompanyNameMutation = {
    updateCompanyName,
    ...updateCompanyMutation,
  };

  return { getCompanyName, setCompanyNameMutation };
}
